module.exports = __webpack_public_path__ + "static/media/group.838d2f75.svg";